// extracted by mini-css-extract-plugin
export default {"container":"NvHomeImpact_container__kx6fX","upperSection":"NvHomeImpact_upperSection__HynD7","lowerSection":"NvHomeImpact_lowerSection__xRVnb"};